import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger";

interface PrimaryButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> {
  label: string;
  loading?: boolean;
  variant?: Variant;
  leadingIcon?: ReactNode;
}

const variantClass: Record<Variant, string> = {
  primary: "bg-primary text-primary-foreground hover:opacity-90",
  secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
  danger: "bg-destructive text-destructive-foreground hover:opacity-90",
};

export function PrimaryButton({
  label,
  loading,
  disabled,
  variant = "primary",
  leadingIcon,
  className = "",
  ...rest
}: PrimaryButtonProps) {
  const isDisabled = disabled || loading;
  return (
    <button
      type="button"
      disabled={isDisabled}
      className={`inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-4 py-3 text-[15px] font-semibold tracking-wide transition-opacity disabled:opacity-50 ${variantClass[variant]} ${className}`}
      {...rest}
    >
      {loading ? (
        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      ) : (
        <>
          {leadingIcon}
          {label}
        </>
      )}
    </button>
  );
}
